import { useQuery, useMutation } from "@apollo/client";
import {
  GET_USER_WALLET,
  GET_USER_WALLET_LEDGERS,
  GET_USER_WITHDRAWAL_REQUESTS,
  CREATE_WITHDRAWAL_REQUEST,
} from "../api/wallet";

export const useUserWallet = () => {
  const { data, loading, error, refetch } = useQuery(GET_USER_WALLET, {
    fetchPolicy: "cache-and-network",
  });

  return {
    wallet: data?.userWallet,
    loading,
    error,
    refetch,
  };
};

export const useWalletLedgers = () => {
  const { data, loading, error, refetch } = useQuery(GET_USER_WALLET_LEDGERS, {
    fetchPolicy: "cache-and-network",
  });

  return {
    ledgers: data?.userWalletLedgers || [],
    loading,
    error,
    refetch,
  };
};

export const useWithdrawalRequests = () => {
  const { data, loading, error, refetch } = useQuery(
    GET_USER_WITHDRAWAL_REQUESTS,
    {
      fetchPolicy: "cache-and-network",
    }
  );

  return {
    withdrawalRequests: data?.userWithdrawalRequests || [],
    loading,
    error,
    refetch,
  };
};

export const useCreateWithdrawalRequest = () => {
  const [createWithdrawalRequest, { loading, error }] = useMutation(
    CREATE_WITHDRAWAL_REQUEST
  );

  return {
    createWithdrawalRequest,
    loading,
    error,
  };
};
